import { render, staticRenderFns } from "./SampleMgmt.vue?vue&type=template&id=54da7230"
import script from "./SampleMgmt.vue?vue&type=script&lang=js"
export * from "./SampleMgmt.vue?vue&type=script&lang=js"
import style0 from "./SampleMgmt.vue?vue&type=style&index=0&id=54da7230&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports